<div class="loading-wrapper {{theme}}">
  <div class="spinner" *ngIf="active">
    <div class="bounce1"></div>
    <div class="bounce2"></div>
    <div class="bounce3"></div>
  </div>
</div>
